import { USAGE } from '../ImplementationReport/tokens';

export const LIBRARY = {
  chipHeight: 40,
  card: { radius: 12, padding: '20px 24px', gap: 24 },
  tick: { size: 20, radius: 4 },
  selbar: { height: 40, bg: USAGE.indigo50 },
  prompt: { size: 20, weight: 500, lineHeight: '28px' },
  filtersWidth: 260,
  listPage: 5,
  teachersShown: 4,
  smallCaseload: USAGE.smallCaseload,
  print: { width: 816, height: 1056, padding: 48, entryHeight: 800, titleBlock: 88 },
} as const;
